import React, { useState } from "react"
import CreateQuoteHero from "@src/components/self-book/create-quote/hero"
import ResponsiveSection from "@src/components/container-responsive-section"
import Options from "@src/components/self-book/create-quote/options"
import FormContext from "@src/components/forms/form-context"
import TripSummary from "@src/components/self-book/create-quote/summary"
import BreadCrumbs from "@src/components/breadcrumbs"
import { getOptionalExtras } from "@src/components/self-book/create-quote/utils/optionalExtras"

const PageCreateQuote = ({ tour }) => {
  const [nights, setNights] = useState(tour.duration.nights)
  const [rooms, setRooms] = useState(0)
  const [extras, setExtras] = useState(0)
  const [passengers, setPassengers] = useState(1)
  const {
    title,
    difficulty,
    pricingTablesNew,
    tourCategory: { name: category },
  } = tour

  const getLatestAvailableDate = matrix => {
    const dateRanges = matrix?.[0]?.rows || []
    const validDates = dateRanges
      .map(row => row.name)
      .filter(name => name && name.includes("to")) // only range rows
      .map(name => {
        const parts = name.split("to")
        if (parts.length !== 2) return null
        const endStr = parts[1].trim()
        const endDate = new Date(endStr)
        return isNaN(endDate) ? null : endDate
      })
      .filter(Boolean) // remove nulls or invalid

    return new Date(Math.max(...validDates.map(d => d.getTime())))
  }

  const lastDate = getLatestAvailableDate(pricingTablesNew)
  const optionalExtras = getOptionalExtras(pricingTablesNew)

  return (
    <FormContext>
      <ResponsiveSection>
        <BreadCrumbs />
      </ResponsiveSection>
      <ResponsiveSection>
        <CreateQuoteHero
          heroImage={tour.images.feature}
          title={title}
          nights={nights}
          category={category}
          difficulty={difficulty}
        />
      </ResponsiveSection>
      <ResponsiveSection>
        <Options
          tourData={tour}
          nights={nights}
          setNights={setNights}
          rooms={rooms}
          setRooms={setRooms}
          setExtras={setExtras}
          setPassengers={setPassengers}
          optionalExtras={optionalExtras}
        />
      </ResponsiveSection>
      <ResponsiveSection>
        <TripSummary
          tour={tour}
          nights={nights}
          rooms={rooms}
          extras={extras}
          lastDate={lastDate}
          passengers={passengers}
          optionalExtras={optionalExtras}
        />
      </ResponsiveSection>
    </FormContext>
  )
}

export default PageCreateQuote
